export const lang_translate = [];
lang_translate["الرجاء تأكد انك ادخلت جميع الخانات قبل التسجيل"]= "الرجاء تأكد انك ادخلت جميع الخانات قبل التسجيل";
lang_translate["الرجاء ادخال كلمة المرور"]= "الرجاء ادخال كلمة المرور";
lang_translate["رقم واحد على الأقل"]= "رقم واحد على الأقل";
lang_translate["8 أحرف على الأقل"]= "8 أحرف على الأقل";
lang_translate["تأكيد كلمة المرور غير متطابق"]= "تأكيد كلمة المرور غير متطابق";

  
  export default {
    lang_translate,
  }